// UPS Shipping/Rating API caps the Name (and AttentionName / Shipper.Name)
// field at 35 characters. Exceeding it triggers UPS error 120200
// "Missing or invalid ship to name".
export const UPS_NAME_MAX = 35;

// Mirror of backend `_clip_ups_name` in backend/ups_shipping.py: prefer
// cutting on the last whitespace boundary <= limit so the printed label
// doesn't chop mid-word; hard-cut single long tokens.
export function clipUpsName(name: string, limit: number = UPS_NAME_MAX): string {
  if (!name || name.length <= limit) return name;
  const head = name.slice(0, limit);
  const cut = head.lastIndexOf(' ');
  if (cut > 0) return head.slice(0, cut).replace(/\s+$/, '');
  return head;
}

export function willUpsTruncate(name: string | null | undefined, limit: number = UPS_NAME_MAX): boolean {
  return !!name && name.length > limit;
}
